<template>
    <client-page>
        <!-- S: 서브 비주얼 -->
        <template #subHead>
            <sub-visual id="irrigation" title="솔루션" src="/images/sub/subvisual-solution.jpg"></sub-visual>
        </template>
        <!-- E: 서브 비주얼 -->

        <page-section class="page-section--first">
            <template #titleLine>
                스마트팜 제품 솔루션
            </template>
            <tit-wrap-large>
                재배지 관리를 손쉽게 만드는 <br class="d-none d-lg-block" /><b>스마트 관수제어 통합 시스템</b>
                <template #text> 재배지의 현재 상태를 진단하여 작물이 필요한 만큼의 관수공급으로 농업용수를 절약하고, <br class="d-none d-lg-block" />구역별 시간, 유량 설정, 수분 포함량 편차에 따른 스마트 관수제어 기능으로 관수를 최적화하여 작물  생장에 도움을 줍니다. </template>
            </tit-wrap-large>

            <v-img max-width="528" :aspect-ratio="528 / 786" src="/images/sub/solution/smartfarm/irrigation-img.png" class="mx-auto" data-aos="fade" data-aos-delay="100" />
        </page-section>

        <v-container>
            <v-divider class="grey lighten-3" />
        </v-container>

        <page-section>
            <page-section class="page-section--sm py-0">
                <template #pageSectionImmersive>
                    <v-row class="mx-n20px my-n10px mx-md-n30px my-md-n20px">
                        <v-col cols="12" md="6" class="px-20px py-10px px-md-30px py-md-20px" data-aos="fade-left" data-aos-delay="200">
                            <v-card outlined rounded="">
                                <v-responsive :aspect-ratio="570 / 456" content-class="d-flex pa-20px">
                                    <v-img max-width="242" :aspect-ratio="242 / 348" src="/images/sub/solution/smartfarm/irrigation-img2.png" class="ma-auto" />
                                </v-responsive>
                            </v-card>
                        </v-col>
                        <v-col cols="12" md="6" class="px-20px py-10px px-md-30px py-md-20px" data-aos="fade-right" data-aos-delay="200">
                            <div class="mt-md-24px">
                                <tit-wrap-sprout>
                                    스마트 관수제어 시스템
                                </tit-wrap-sprout>

                                <txt-item>
                                    <template #title>제어항목</template>
                                    시간제어, 광량제어,무게제어
                                    <div class="font-size-16 font-size-md-18">*중량제어 기반 양액관리 알고리즘 탑재</div>
                                </txt-item>
                                <txt-item>
                                    <template #title>관수방식</template>
                                    시간관수, 유량관수, 함수량 관수
                                </txt-item>
                                <txt-item>
                                    <template #title>설정항목</template>
                                    구역 설정 (최대 10개)<br />구역별 관수주기<br />관수기간<br />구역별 EC, pH 개별 설정<br />작물 1주당 관수량<br />EC, pH 상하한경보
                                </txt-item>
                                <txt-item>
                                    <template #title>조회항목</template>
                                    양액기 운영 기록, 근권부 모니터링 기록, <br class="d-none d-lg-block" />온실환경 실시간 및 기간별 조회
                                </txt-item>
                                <txt-item>
                                    <template #title>기타기능</template>
                                    긴급상황 수동관수 기능
                                </txt-item>
                            </div>
                        </v-col>
                    </v-row>
                </template>
            </page-section>

            <page-section class="page-section--sm pb-0">
                <template #pageSectionImmersive>
                    <v-card rounded="" color="grey lighten-5" data-aos="fade" data-aos-delay="100">
                        <v-responsive :aspect-ratio="1200 / 770" content-class="d-flex align-center justify-center">
                            <div class="pa-30px pa-md-40px px-lg-80px">
                                <v-img max-width="600" :width="$vuetify.breakpoint.lgAndUp ? '600' : ''" :aspect-ratio="600 / 376" src="/images/sub/solution/smartfarm/irrigation-img3.png" class="mx-auto" />
                                <div class="pt-30px pt-md-40px pt-lg-60px">
                                    <tit-wrap-small>
                                        웹과 모바일 앱에서 쉽고 간편한 실시간 모니터링
                                        <template #text> 양액기 운영기록과 근권부 모니터링, 온실환경 등 다양한 기록을 통해 <br class="d-none d-lg-block" />재배환경 설정 판단을 도와주는 시스템입니다. </template>
                                    </tit-wrap-small>
                                </div>
                            </div>
                        </v-responsive>
                    </v-card>
                </template>
            </page-section>

            <page-section class="page-section--sm pb-0">
                <template #pageSectionImmersive>
                    <v-row justify="center">
                        <v-col cols="12" md="6" lg="4" data-aos="fade" data-aos-delay="100">
                            <v-card outlined rounded="">
                                <v-img max-width="382" :aspect-ratio="382 / 540" src="/images/sub/solution/smartfarm/irrigation-img4.jpg" class="ma-auto" />
                            </v-card>
                            <tit-wrap-small mbSmall class="mt-14px mt-md-20px">
                                특허등록
                                <template #text>
                                    양액재배 관리장치
                                </template>
                            </tit-wrap-small>
                        </v-col>
                    </v-row>
                </template>
            </page-section>
        </page-section>

        <page-section class="grey lighten-5">
            <page-section class="page-section--sm py-0">
                <tit-wrap-large class="tit-wrap--lg"> 식물 뿌리 환경을 관리하는 <br class="d-none d-lg-block" /><b>스마트 관수 All In One 솔루션</b> </tit-wrap-large>

                <v-row align="center" justify="center" class="row--lg">
                    <v-col cols="12" sm="6" lg="4" data-aos="fade-up" data-aos-delay="100">
                        <v-card rounded="" class="text-center">
                            <v-responsive :aspect-ratio="372 / 210" content-class="d-flex align-center justify-center">
                                <div class="pa-20px">
                                    <div>
                                        <v-img max-width="40" :aspect-ratio="40 / 30" src="/images/icon/icon-sprout.svg" class="mx-auto" />
                                        <div class="mt-16px mt-md-24px">
                                            <p class="txt txt--lg txt--dark line-height-15">근권환경 수분 포함량을 <br class="d-md-none d-lg-block" />기반으로 한 관수 시스템 적용</p>
                                        </div>
                                    </div>
                                </div>
                            </v-responsive>
                        </v-card>
                    </v-col>
                    <v-col cols="12" sm="6" lg="4" data-aos="fade-up" data-aos-delay="200">
                        <v-card rounded="" class="text-center">
                            <v-responsive :aspect-ratio="372 / 210" content-class="d-flex align-center justify-center">
                                <div class="pa-20px">
                                    <div>
                                        <v-img max-width="40" :aspect-ratio="40 / 30" src="/images/icon/icon-sprout.svg" class="mx-auto" />
                                        <div class="mt-16px mt-md-24px">
                                            <p class="txt txt--lg txt--dark line-height-15">근권환경 데이터 학습을 통한 <br class="d-md-none d-lg-block" />관수제어 알고리즘 생성</p>
                                        </div>
                                    </div>
                                </div>
                            </v-responsive>
                        </v-card>
                    </v-col>
                    <v-col cols="12" sm="6" lg="4" data-aos="fade-up" data-aos-delay="300">
                        <v-card rounded="" class="text-center">
                            <v-responsive :aspect-ratio="372 / 210" content-class="d-flex align-center justify-center">
                                <div class="pa-20px">
                                    <div>
                                        <v-img max-width="40" :aspect-ratio="40 / 30" src="/images/icon/icon-sprout.svg" class="mx-auto" />
                                        <div class="mt-16px mt-md-24px">
                                            <p class="txt txt--lg txt--dark line-height-15">근권환경 측정을 통한 <br class="d-md-none d-lg-block" />통합 솔루션 제공</p>
                                        </div>
                                    </div>
                                </div>
                            </v-responsive>
                        </v-card>
                    </v-col>
                </v-row>
            </page-section>

            <page-section class="page-section--sm pb-0">
                <v-img max-width="814" :aspect-ratio="814 / 670" src="/images/sub/solution/smartfarm/irrigation-img5.png" class="ma-auto" data-aos="fade" data-aos-delay="400" />
            </page-section>
        </page-section>

        <page-section id="irrigation-portfolio" class="page-section--last">
            <template #title>
                포트폴리오
            </template>
            <div></div>

            <template #pageSectionImmersive>
                <div style="max-width:1480px" class="mx-auto px-12px">
                    <irrigation-slide />
                </div>
            </template>
        </page-section>
    </client-page>
</template>

<script>
import ClientPage from "@/pages/client/templates/ClientPage.vue";
import SubVisual from "@/components/client/sub/sub-visual.vue";
import PageSection from "@/pages/client/templates/page-section.vue";
import TitWrapSmall from "@/components/dumb/tit-wrap-small.vue";
import TitWrapLarge from "@/components/dumb/tit-wrap-large.vue";
import TitWrapSprout from "@/components/dumb/tit-wrap-sprout.vue";
import TxtItem from "@/components/dumb/txt-item.vue";
import IrrigationSlide from "@/pages/client/sub/solution/IrrigationSlide.vue";

export default {
    components: {
        ClientPage,
        SubVisual,
        PageSection,
        TitWrapSmall,
        TitWrapLarge,
        TitWrapSprout,
        TxtItem,
        IrrigationSlide,
    },
    props: {},
    data() {
        return {
        };
    },
    mounted() {
        this.init();
    },
    methods: {
        async init() {
            this.$nextTick(() => {});
        },
    },
};
</script>

<style lang="scss" scoped></style>
